import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useStorage from '../../../../hooks/useStorage';

const { Box, Button, Title, Table } = vp;

type FC = FunctionComponent;

const SignersDetailsContainer: FC = () => {
  const { t } = useTranslation('translations', { keyPrefix: 'SignerDetailsContainer' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const query = new URLSearchParams(useLocation().search);
  const state = {
    signer: {
      ID: query.get('ID') || '',
      FullName: query.get('FullName') || '',
      DOB: query.get('DOB') || '',
      Occupation: query.get('Occupation') || '',
      EmailAddress: query.get('EmailAddress') || '',
      HomeAddress: query.get('HomeAddress') || '',
      DocumentSigned: query.get('DocumentSigned') || '',
      DateAdded: query.get('DateAdded') || '',
    },
  };
  const {
    signerCreation: { storeSignerCreation },
  } = useStorage();

  const tableProps1: vp.TableProps = {
    name: 'signer-details-list1',
    variant: 'form',
    columns: {
      FullName: { header: t('Columns.fullName', { defaultValue: 'Full Name*' }), align: 'left' },
      EmailAddress: { header: t('Columns.emailAddress', { defaultValue: 'Email Address*' }), align: 'left' },
      Title: { header: t('Columns.title', { defaultValue: 'Title*' }), align: 'left' },
    },
    rows:
      Object.values(state).map((signer) => ({
        FullName: signer.FullName,
        EmailAddress: signer.EmailAddress,
        Title: signer.Occupation,
      })) || [],
  };

  return (
    <>
      <Box mt="lg" mb="lg" flx="col">
        <Title title={t('title', { defaultValue: 'Signer Details' })} />
      </Box>
      <Table {...tableProps1} />
      <Box jc="fe" pt="lg" mt="lg" gap="md">
        <Button
          id="back-to-signers-btn"
          label={tGlobal('Buttons.back')}
          color="primary"
          width="223px"
          noShadow
          round
          onClick={() => {
            history.back();
            storeSignerCreation('signerChange');
          }}
        />
      </Box>
    </>
  );
};

export default SignersDetailsContainer;
